import { render, staticRenderFns } from "./priceSetting.vue?vue&type=template&id=1450b523&"
import script from "./priceSetting.vue?vue&type=script&lang=js&"
export * from "./priceSetting.vue?vue&type=script&lang=js&"
import style0 from "./priceSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports